export default "__VITE_PUBLIC_ASSET__fa3989aa__"